import { Truncate } from '@cleartrip/bento/lib';
import Sandbox from '@components/Sandbox';
import Playground from '@components/Playground';
import * as React from 'react';
export default {
  Truncate,
  Sandbox,
  Playground,
  React
};